/**
 * .tuMetrics {"tu1": 0.98, "tu2": 0.99, "tu3": 1, "notes": "What's new, Reports, Master Control desk addresses", "tuVersion": "2.5"}
 * .help "Desk pages share the stream shell. What's new, Reports, and Master Control live at top-level paths."
 */

/** Changelog / release notes. */
export const UPDATES_ROUTE = '/updates';

/** Platform HQ desk. */
export const MASTER_CONTROL_ROUTE = '/master-control';

/** Time and project reports. Owner / administrator / executive / manager. */
export const REPORTS_ROUTE = '/reports';
